export default __webpack_public_path__ + "static/media/chdr.0c3050b8.svg";